__turbopack_context__.v({
  "metaBlock": "-maxYG_metaBlock",
  "metaGrid": "-maxYG_metaGrid",
  "metaLabel": "-maxYG_metaLabel",
  "metaLeft": "-maxYG_metaLeft",
  "metaOverview": "-maxYG_metaOverview",
  "metaRight": "-maxYG_metaRight",
  "metaSection": "-maxYG_metaSection",
  "metaText": "-maxYG_metaText",
  "metaTools": "-maxYG_metaTools",
  "page": "-maxYG_page",
  "pipelineCaption": "-maxYG_pipelineCaption",
  "pipelineDiagram": "-maxYG_pipelineDiagram",
  "pipelineSvg": "-maxYG_pipelineSvg",
  "schemaExample": "-maxYG_schemaExample",
});
